module.exports = __webpack_public_path__ + "static/img/数据存储与管理.d0eedf59.png";